import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ProductTree from "./ProductTree";
import ProductCreate from "./ProductCreate";
import ProductView from "./ProductView";
import { useRecoilState, useRecoilValue } from "recoil";
import { items, menuAdmin } from "@recoil/Store";
import { useLocation } from "react-router-dom";
import * as Const from "@utils/Const";
import ProductList from "./ProductList";
import ProductUpdate from "./ProductUpadte";
export default function ProductMain() {
    const { pathname } = useLocation();
    const [item, setItem] = useRecoilState(items);
    const menus = useRecoilValue(menuAdmin);
    let curMenu = menus && menus.filter((val) => (val.tabUrl === pathname))[0];
    let menu = curMenu && curMenu.subMenus;
    return (_jsx(_Fragment, { children: _jsxs("main", Object.assign({ className: "product-manager" }, { children: [menu &&
                    _jsx(ProductTree, { menu: menu, item: item, setItem: setItem }), (item && item.type === Const.TYPE_L) && (item.tab === Const.AD_P) &&
                    _jsx(ProductList, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_V) && (item.tab === Const.AD_P) &&
                    _jsx(ProductView, { item: item, setItem: setItem }), (item && item.type === Const.TYPE_P) && (item.tab === Const.AD_P) &&
                    _jsx(ProductUpdate, { item: item, setItem: setItem, menu: menu }), (item && item.type === Const.TYPE_C) && (item.tab === Const.AD_P) &&
                    _jsx(ProductCreate, { tem: item, setItem: setItem, menu: menu })] })) }));
}
